var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsGreenApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66433 13.8864L3.176 8.62674L0.819336 10.8852L8.66433 18.4033L24.8427 2.8991L22.486 0.640625L8.66433 13.8864Z",
    fill: "#00BB2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGreenApproved);
export default __webpack_public_path__ + "static/media/icons-green-approved.89871401ed4a4fa2f8ece334b653c3ac.svg";
export { ForwardRef as ReactComponent };